import { render } from "./QUMReport.vue?vue&type=template&id=2439e2ff&scoped=true"
import script from "./QUMReport.vue?vue&type=script&lang=js"
export * from "./QUMReport.vue?vue&type=script&lang=js"

import "./QUMReport.vue?vue&type=style&index=0&id=2439e2ff&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2439e2ff"]])

export default __exports__